var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isAuthenticated)?_c('div',[_c('NavbarMenu'),_c('keep-alive',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"view"})],1)],1),_c('TheFooter')],1):_c('div',[_c('Login')],1),_c('notifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }